import { ButtonColor } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { CheckBox } from '@lmt/unicorn-shared/app/components/common/ui-kit/CheckBox';
import { useModal } from '@lmt/unicorn-shared/app/components/common/ui-kit/modal/useModal';
import { GenerateDataOptions } from '@lmt/unicorn-shared/app/helpers/generateTestData';
import i18n from 'i18next';
import React from 'react';
import styles from './generate-data-dialog.module.scss';

export function showGenerateDataDialog(modals: ReturnType<typeof useModal>) {
  return modals.showCustom<GenerateDataOptions>({
    title: i18n.t(
      'tenant_settings.general_settings.generate_test_data.confirmation_title',
    ),
    defaultValue: {
      generateAdditionalSubtenants: false,
    },
    Component: (props) => {
      return (
        <div className={styles.modalContainer}>
          <span>
            {i18n.t(
              'tenant_settings.general_settings.generate_test_data.confirmation_text',
            )}
          </span>
          <CheckBox
            className={styles.subtenantsCheckbox}
            title={i18n.t(
              'tenant_settings.general_settings.generate_test_data.generate_additional_subtenants',
            )}
            checked={props.value?.generateAdditionalSubtenants}
            onChange={(e) =>
              props.setValue({
                generateAdditionalSubtenants: e.currentTarget.checked,
              })
            }
          />
        </div>
      );
    },
    okButtonText: i18n.t(
      'tenant_settings.general_settings.generate_test_data.confirmation_button',
    ),
    okButtonColor: ButtonColor.Danger,
  });
}
